import { TIncomeFieldsValues } from '../../formDefinitions/IncomeInfoForm/IncomeInfoFields'
import { affiliateAlternativeOffertsNames, affiliatePartnersNames } from '../../pages/AffiliatePage/affiliatePartnersData'


// ========================================== AFFILIATE DATA MODELS ====================================
export interface IAffiliateUrlParamsModel {
   [key: string]: string;
}

export interface IAffiliateDataModel {
   partnerId: affiliatePartnersNames;
   clientId: string | null;
   alternativeOffertNameFromFront?: affiliateAlternativeOffertsNames;
   urlParams: IAffiliateUrlParamsModel 
}

export interface IPredefinedAffiliateDataModel {
   alternativeOffertNameFromFront: affiliateAlternativeOffertsNames;
}
// ======================================================================================================




// ========================================== CONSENTS MODEL ============================================
export interface IAppConsentsModelToSend {
   id: number;
   text: string;
   isConsent: boolean;
}
// =======================================================================================================




// ========================================== APPLICANT DATA MODELS =======================================
export enum ApplicantDataFieldNames {
   name = "name",
   surname = "surname",
   pesel = "pesel",
   type = "type",
   street = "street",
   houseNumber = "houseNumber",
   apartmentNumber = "apartmentNumber",
   postalCode = "postalCode",
   city = "city",
   phone = "phone",
   userEmail = "userEmail",
   personalId = "personalId",
   personalIdRelease = "personalIdRelease",
   personalIdValidity = "personalIdValidity",
   maritalStatus = "maritalStatus",
   education = "education",
   costOfLiving = "costOfLiving"
}

export enum ApplicantDataIncomeFieldNames { //Nazwy pól z modelu danych używanym w Backendzie
   type = 'type',
   incomePerMonth = 'incomePerMonth',
   incomeReceivedFromDate = 'incomeReceivedFromDate',
   incomeReceivedToDate = 'incomeReceivedToDate',
   incomeReceivedDay = 'incomeReceivedDay',
   NIP = 'nip',
   companyName = 'companyName',
   totalIncome = 'totalIncome',
   benefitsAmount = 'benefitsAmount',
   unionGrantsAmount = 'unionGrantsAmount',
}

export interface ILoanApplicantDataContactModel {
   [ApplicantDataFieldNames.phone]: string;
   [ApplicantDataFieldNames.userEmail]: string;
}

export type ILoanApplicantDataAddressModel = {
   [ApplicantDataFieldNames.type]: string;
   [ApplicantDataFieldNames.street]: string;
   [ApplicantDataFieldNames.houseNumber]: string;
   [ApplicantDataFieldNames.apartmentNumber]: string;
   [ApplicantDataFieldNames.postalCode]: string;
   [ApplicantDataFieldNames.city]: string;
} 
   |
{
   [ApplicantDataFieldNames.type]?: string;
   [ApplicantDataFieldNames.street]: string;
   [ApplicantDataFieldNames.houseNumber]?: string;
   [ApplicantDataFieldNames.apartmentNumber]?: string;
   [ApplicantDataFieldNames.postalCode]?: string;
   [ApplicantDataFieldNames.city]?: string;
}

export type ILoanApplicantDataModel = {
   [ApplicantDataFieldNames.name]: string;
   [ApplicantDataFieldNames.surname]: string;
   [ApplicantDataFieldNames.pesel]: string;
   [ApplicantDataFieldNames.personalId]: string; 
   [ApplicantDataFieldNames.personalIdRelease]: string; 
   [ApplicantDataFieldNames.personalIdValidity]: string;
   [ApplicantDataFieldNames.maritalStatus]: string;
   [ApplicantDataFieldNames.education]: string;
   [ApplicantDataFieldNames.costOfLiving]: number;
   contactData: ILoanApplicantDataContactModel;
   addressData: ILoanApplicantDataAddressModel[];
   incomeData: TIncomeFieldsValues[];
}
// ======================================================================================================




// ========================================== LOAN DATA MODELS ==========================================
export interface IAdditionalLoanDataModel {
   loanAmount: number;
   loanInstalments: number;
   hdim: string | null;
   jsc: string | null;
   fillTime: number | null;
}
// =======================================================================================================




// ========================================== FORM SUBMISSION MODEL =======================================
export interface IFormSubmissionModel {
   loan: IAdditionalLoanDataModel;
   applicant: ILoanApplicantDataModel;
   consents: IAppConsentsModelToSend[];
   affiliate?: IAffiliateDataModel;
   hdim: string | null;
   jsc: string | null;
   fillTime: number | null;
}
// =======================================================================================================
